import React, { useEffect, useCallback } from 'react'
import { BTitle, BText, BSpinner } from '@prague-digi/ui-components'
import { compose } from 'redux'
import { connect } from 'react-redux'

import { intl, IntlInterface, wizard, WizardInterface } from '../../hoc'
import { contractActions, modalDialogActions } from '../../redux'
import messages from '../../i18n'
import { ErrSuccess } from '../../types/form'
import { Response } from '../../api/api'
import { API_ERROR } from '../../constants/modals'

interface DispatchProps {
  signContract: (callbacks: ErrSuccess) => void
  showModalDialog: Function
}

type Props = IntlInterface & WizardInterface & DispatchProps

export const ContractSign = ({ translate, signContract, wizard, showModalDialog }: Props) => {
  const init = useCallback(() => {
    const onInitError = (errorType: Response) => {
      showModalDialog(
        API_ERROR({
          errorInfo: { type: errorType },
          onRetry: init,
        })
      )
    }

    signContract({ success: wizard.gotoNext, error: onInitError })
  }, [showModalDialog, signContract, wizard.gotoNext])

  useEffect(() => {
    init()
  }, [init])

  return (
    <>
      <BTitle center type="h3">
        {translate(messages.ContractSign.title)}
      </BTitle>
      <BText center type="secondary">
        {translate(messages.ContractSign.subTitle)}
      </BText>
      <BSpinner isShown isStatic style={{ zIndex: 0 }} />
    </>
  )
}

const mapDispatchToProps: DispatchProps = {
  signContract: contractActions.signContract,
  showModalDialog: modalDialogActions.showModalDialog,
}

const enhance = compose(intl, wizard, connect(null, mapDispatchToProps))

export default enhance(ContractSign)
